module.exports = __webpack_public_path__ + "img/example-security-mri-zone.c24b65f8.jpg";